import { api } from '@/api/api-client.config.ts';
import { PageType } from '@/@types/api.types.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const updatePage = (page: PageType) =>
  api.put(`/admin/pages/${page.page_id}`, page);

export const useUpdatePageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updatePage'],
    mutationFn: updatePage,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getPickemRules'],
      });
    },
  });
};
